import { defineStore } from 'pinia'
import { getHealthReportV2Unread } from '@/api/activity'

/**
 * 健康日报 / 周报 V2 未读状态
 * 供首页「报告」Tab 红点共享
 */
export const useHealthReportV2UnreadStore = defineStore('healthReportV2Unread', {
  state: () => ({
    /** 是否有未读日报 */
    hasUnreadDaily: false,
    /** 未读日报数量 */
    unreadDailyCount: 0,
    /** 是否有未读周报 */
    hasUnreadWeekly: false,
    /** 未读周报数量 */
    unreadWeeklyCount: 0,
    /** 是否正在请求 */
    loading: false
  }),
  getters: {
    /**
     * 是否有任意未读（日报或周报）
     * @returns {boolean}
     */
    hasUnread(state) {
      return !!(
        state.hasUnreadDaily ||
        state.hasUnreadWeekly ||
        state.unreadDailyCount > 0 ||
        state.unreadWeeklyCount > 0
      )
    }
  },
  actions: {
    /**
     * 拉取未读统计（GET /health-report/v2/query/unread）
     * @returns {Promise<void>}
     */
    async fetchUnread() {
      this.loading = true
      try {
        const res = await getHealthReportV2Unread()
        if (res && (res.code === '1000' || res.code === 1000) && res.data) {
          const data = res.data || {}
          this.hasUnreadDaily = !!data.hasUnreadDaily
          this.unreadDailyCount = Number(data.unreadDailyCount) || 0
          this.hasUnreadWeekly = !!data.hasUnreadWeekly
          this.unreadWeeklyCount = Number(data.unreadWeeklyCount) || 0
          if (!this.hasUnreadDaily && this.unreadDailyCount > 0) {
            this.hasUnreadDaily = true
          }
          if (!this.hasUnreadWeekly && this.unreadWeeklyCount > 0) {
            this.hasUnreadWeekly = true
          }
          return
        }
        this.clearAll()
      } catch (e) {
        this.clearAll()
      } finally {
        this.loading = false
      }
    },
    /**
     * 本地标记一条日报已读（成功后乐观更新）
     * @returns {void}
     */
    applyLocalDailyRead() {
      this.unreadDailyCount = Math.max(0, this.unreadDailyCount - 1)
      this.hasUnreadDaily = this.unreadDailyCount > 0
    },
    /**
     * 本地标记一条周报已读（成功后乐观更新）
     * @returns {void}
     */
    applyLocalWeeklyRead() {
      this.unreadWeeklyCount = Math.max(0, this.unreadWeeklyCount - 1)
      this.hasUnreadWeekly = this.unreadWeeklyCount > 0
    },
    /**
     * 清空未读
     * @returns {void}
     */
    clearAll() {
      this.hasUnreadDaily = false
      this.unreadDailyCount = 0
      this.hasUnreadWeekly = false
      this.unreadWeeklyCount = 0
    }
  }
})



// WEBPACK FOOTER //
// ./src/stores/healthReportV2Unread.js